// Вкладка «Документы»: файлы, приложенные к карточке.
//
// ПОЧЕМУ ФАЙЛ — НЕ КОЛОНКА КАРТОЧКИ. В Bitrix файловых полей у сделки несколько десятков,
// и каждое — своё: «АВР файл», «Счет продажа (файл)1», «Фото отгрузка». Из-за этого один
// и тот же скан лежит в трёх полях, а найти его можно, только помня, в какое его клали.
// В своей схеме файл — это запись со ссылкой на сущность и РОЛЬЮ («скан акта», «фото
// отгрузки»), поэтому здесь одна таблица с колонкой «Роль», а не тридцать полей.
//
// ЧЕГО ЗДЕСЬ ПОКА НЕТ. Скачивания: ссылка наружу должна быть подписанной и с истечением,
// а подписывать её некому — транспорта ещё нет. Показывать кнопку, которая не работает,
// хуже, чем сказать об этом прямо.

import { fmtDate } from '../lib/format'

import type { Файл } from './types'
import type { Ответ } from './useSourceData'

/** Байты человеку. Килобайт здесь — тысяча, а не 1024: это подпись, а не расчёт. */
function размер(байт: number): string {
  if (байт < 1000) return `${байт} Б`
  if (байт < 1000 * 1000) return `${Math.round(байт / 1000)} КБ`
  return `${(байт / 1000 / 1000).toFixed(1)} МБ`
}

/**
 * Данные приходят пропом, а не запрашиваются здесь: их же считает счётчик на полосе
 * вкладок, и запрашивать список дважды ради одного числа — та самая ошибка N+1,
 * от которой в проекте стоит отдельный набор проверок.
 */
export function DocsTab({ ответ }: { ответ: Ответ<Файл[]> }) {
  const { данные, отказ, ждём } = ответ

  return (
    <div className="card">
      <h2>Приложенные файлы</h2>
      {отказ && (
        <div className="notice err">
          Список файлов не пришёл: {отказ}. Пустая таблица здесь означала бы «вложений нет»,
          поэтому мы её не показываем.
        </div>
      )}
      {!отказ && ждём && <div className="skeleton" />}
      {!отказ && !ждём && данные && данные.length === 0 && (
        <div className="empty">
          <div className="empty-title">Вложений нет</div>
          <div className="empty-hint">
            К карточке не приложено ни одного файла. Это ответ «ноль», а не «не загрузилось».
          </div>
        </div>
      )}
      {!отказ && !ждём && данные && данные.length > 0 && (
        <>
          <div className="table-wrap cards">
            <table>
              <thead>
                <tr>
                  <th>Файл</th>
                  <th>Роль</th>
                  <th className="num">Размер</th>
                  <th>Добавил</th>
                  <th>Когда</th>
                </tr>
              </thead>
              <tbody>
                {данные.map((ф) => (
                  <tr key={ф.id}>
                    <td data-label="Файл">{ф.имя}</td>
                    <td data-label="Роль">{ф.роль ?? '—'}</td>
                    <td data-label="Размер" className="num">{размер(ф.размер)}</td>
                    <td data-label="Добавил">{ф.добавил ?? '—'}</td>
                    <td data-label="Когда">{ф.когда ? fmtDate(ф.когда, true) : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="hint">
            Скачивание появится вместе с хранилищем: ссылка наружу должна быть подписанной
            и с истечением, иначе файл открывается без авторизации у любого, кому её переслали.
          </div>
        </>
      )}
    </div>
  )
}
